/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CreateOutletResponseDTO = {
  address?: string;
  balance?: number;
  commissionWalletId?: number;
  createdAt?: string;
  id?: string;
  name?: string;
  status?: CreateOutletResponseDTO.status;
  wallet?: string;
  walletId?: number;
};

export namespace CreateOutletResponseDTO {
  export enum status {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
  }
}
